import { Modal, Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PreviewModeModal = ({ open, onClose }) => {

  const { t } = useTranslation();
  const handleGotIt = () => {
    onClose();
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable
      className="preview-mode-modal"
    >
      <h2 style={{ fontWeight: 600, fontSize: 24, marginBottom: 16, color: 'var(--color-heading)' }}>
        {t("experiences.preview_mode.title")}
      </h2>
      <p style={{ color: 'var(--color-heading)', marginBottom: 32 }}>
        {t("experiences.preview_mode.description")}
      </p>
      <Button type="default" onClick={handleGotIt} style={{ borderRadius: 24, padding: '4px 20px', height: '44px', borderColor: 'var(--color-primary)', border: "1.5px solid", color: 'var(--color-primary)', backgroundColor: 'var(--color-bg)', fontWeight: 500, fontSize: 14 }}>
        {t("global.got_it")}
      </Button>
    </Modal>
  );
};

PreviewModeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PreviewModeModal; 